export const AG_GRID_GROUP_AUTO_COLUMN_ID = 'ag-Grid-AutoColumn';

export const MAX_GROUPED_COLUMNS = 3;
export const SORTABLE_GROUPING_SECTION_CLASS_NAME = 'sortable_grouping_section';
export const SORTABLE_GROUPING_ITEM_CLASS_NAME = 'sortable_grouping_item';
